module.exports = __webpack_public_path__ + "img/architecture2.9060292a.png";